import { z } from 'zod';
// ── Tax Accounts ────────────────────────────────────
export const createTaxAccountSchema = z.object({
    authorityId: z.string().uuid(),
    accountNumber: z.string().min(1).max(50),
    accountType: z.enum(['corporate', 'payroll', 'sales_tax', 'other']),
    nickname: z.string().max(100).optional(),
});
export const updateTaxAccountSchema = z.object({
    accountNumber: z.string().min(1).max(50).optional(),
    accountType: z.enum(['corporate', 'payroll', 'sales_tax', 'other']).optional(),
    nickname: z.string().max(100).nullable().optional(),
    isActive: z.boolean().optional(),
});
// ── Tax Obligations ─────────────────────────────────
export const createTaxObligationSchema = z.object({
    taxAccountId: z.string().uuid(),
    programId: z.string().uuid(),
    periodStart: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    periodEnd: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    expectedAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).optional(),
    filedAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).optional(),
    paidAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).optional(),
    status: z.enum(['draft', 'due', 'filed', 'paid', 'overdue', 'partial']).optional(),
    calculationSource: z.enum(['manual', 'calculated', 'imported']).optional(),
    notes: z.string().max(1000).optional(),
});
export const updateTaxObligationSchema = z.object({
    expectedAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).nullable().optional(),
    filedAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).nullable().optional(),
    paidAmount: z.string().regex(/^-?\d+(\.\d{1,2})?$/).nullable().optional(),
    status: z.enum(['draft', 'due', 'filed', 'paid', 'overdue', 'partial']).optional(),
    notes: z.string().max(1000).nullable().optional(),
});
export const generateObligationsSchema = z.object({
    taxAccountId: z.string().uuid(),
    programId: z.string().uuid(),
    year: z.number().int().min(2020).max(2050),
    remitterType: z.string().optional(),
});
// ── Tax Payments ────────────────────────────────────
export const createTaxPaymentSchema = z.object({
    obligationId: z.string().uuid().optional(),
    taxAccountId: z.string().uuid(),
    programId: z.string().uuid(),
    amount: z.string().regex(/^\d+(\.\d{1,2})?$/),
    paymentDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    confirmationNumber: z.string().max(100).optional(),
    paymentMethod: z.enum(['bank_portal', 'cheque', 'other']).optional(),
    sourceBankAccount: z.string().max(100).optional(),
    formData: z.record(z.string(), z.unknown()).optional(),
    notes: z.string().max(1000).optional(),
});
export const updateTaxPaymentSchema = z.object({
    amount: z.string().regex(/^\d+(\.\d{1,2})?$/).optional(),
    paymentDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    confirmationNumber: z.string().max(100).nullable().optional(),
    paymentMethod: z.enum(['bank_portal', 'cheque', 'other']).optional(),
    sourceBankAccount: z.string().max(100).nullable().optional(),
    formData: z.record(z.string(), z.unknown()).nullable().optional(),
    notes: z.string().max(1000).nullable().optional(),
    status: z.enum(['pending', 'completed', 'failed', 'reversed']).optional(),
});
export const confirmReconciliationSchema = z.object({
    transactionId: z.string().uuid(),
});
//# sourceMappingURL=tax.js.map